import CryptoJS from "crypto-js";

export function setCookie(name, value, days) {
  let date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  let expires = "; expires=" + date.toGMTString();
  document.cookie = name + "=" + value + expires + "; path=/";
}

export function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

export function clearCookie(name) {
  setCookie(name, "", -1);
}

export function stringToHash(str) {
  try {
    // 创建一个 SHA-256 哈希对象
    const sha256Hash = CryptoJS.SHA256(str);
    // 将哈希值转换为字节数组
    const hashBytes = CryptoJS.enc.Hex.parse(
      sha256Hash.toString(CryptoJS.enc.Hex)
    );
    // 火山支持的 deviceid 必须为非负数，且 <= long.MaxValue
    const hashValue =
      BigInt("0x" + hashBytes.toString()) & BigInt(Number.MAX_SAFE_INTEGER);
    return hashValue.toString();
  } catch (error) {
    console.log("获取设备ID失败：" + error.message);
    return "0";
  }
}
